/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import Typography from "@fdn/typography";
import getSlugbrand from "Helpers/handleSlugBrand";
import TabsButton from "components/button/tabsButton";
import {
	beautyLevelHandle, handleImage, imageDynamic, imageDynamic2,
} from "Helpers/utils";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import CardReviewSkeleton from "../../components/skeleton/card_review/cardReview";

const ReviewCard = dynamic(
	() => import("@fdn/review_card"), {
		ssr: true,
	},
);

const Desktop = (props) => {

	const storeData = useSelector((state) => state);

	const prop = props;

	return (
		<>
			<div className="home-review">
				<div className="home-top">
					<Typography
						id_element="highlight-review"
						type="type-1"
						text="TRENDING REVIEWS"
						color="#F3BDCA"
						font_family="Poppins"
						font_size={40}
						font_weight={600}
						stroke_color="#454F5B"
						stroke_width="0.480209px"
						tail={false}
					/>
					<div className="tabs-container">
						{prop.tabList.map((data, idx) => (

							<TabsButton
								key={idx}
								isMobile={prop.isMobile}
								name={data.title}
								type={data.type}
								tabChoose={prop.tabChoose}
								handleChangeTabs={prop.handleChangeTabs}
							/>

						))}
					</div>
				</div>

				{ storeData.storeReview.is_loading && !prop.newestReviews.on_load
					? (
						<div className="home-review-list-trending">
							{
								Array.from({ length: 5 }, (_index, idx) => (
									<CardReviewSkeleton key={idx} />
								))
							}
						</div>

					)
					:	storeData.storeReview.data && prop.newestReviews.data.length > 0 ? (
						<>
							<div className="home-review-list-trending">
								{prop.newestReviews.data.map((review, id) => (
									<div
										id={`id_review_desc_${prop.id}`}
										key={id}
										className="home-component-review-card"
									>

										<ReviewCard
											key={review.id}
											is_mobile={prop.isMobile}
											type="1"
											product={{
												...review.product,
												image: review.product.image.match(
													/image.femaledaily.com/,
												)
													? imageDynamic2(review.product.image, 250)
													: imageDynamic(review.product.image, 250),
											}}
											product_url={`${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/products/${review?.product.category?.parent?.slug}/${review?.product.category?.slug}/${review?.product?.brand?.slug}/${review.product.slug}`}
											brand_url={`${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/brands/${getSlugbrand(review?.product?.brand)}`}
											product_photos={review.photos}
											handle_product_photos={(data) => prop.handleImageView(data, review.photos)}
											brand_name={review?.product?.brand.name}
											profile={review.user}
											self={prop.self.data}
											sso_domain={process.env.NEXT_PUBLIC_SSO_DOMAIN}
											profile_url={`${process.env.NEXT_PUBLIC_SSO_DOMAIN}/user/fd/${review.user.username}`}
											profile_image={handleImage(
												review.user.picture,
												100,
												"user",
											)}
											profile_age={(
												<div className="profile-info">
													{`${review.user.age_range}`}
													{" "}
													・
													<img
														className="beauty-level__image"
														width={16}
														height={16}
														src={`https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/beauty-level/levels/${beautyLevelHandle(review.user.beauty_level)}.png`}
														alt={`icon-${review.user.beauty_level || "bronze"}`}
													/>
													<p className="beauty-level">
														{beautyLevelHandle(review.user.beauty_level)}
													</p>
												</div>
											)}
											profile_description={`${
												review.user.skin.type ? `${review.user.skin.type}, ` : ""
											}${review.user.skin.tone ? review.user.skin.tone : ""}${
												review.user.skin.undertone
													? `, ${review.user.skin.undertone}`
													: ""
											}`}
											review={review}
											review_recommended={review.is_recommended}
											open_login={prop.open_login}
											handle_like={prop.handle_like}
											expand_text={prop.handleExpandText}
											open_report={prop.handleOpenReport}
											goto_add_review={() => prop.goToEditReview({
												id: review.id,
												slug: review.product.slug,
											})}
											// for comments
											toggle_comment={prop.toggle_comment}
											is_more_comments={(review?.comments?.data?.length < review.total_comments)}
											load_comments={prop.load_comments}
											handle_input={prop.handle_input}
											handle_comment={prop.handle_comment}
											comment_count_id={`comment-count-${review.id}`}
											comment_form_id={`comment-form-${review.id}`}
											comment_submit_id={`comment-button-${review.id}`}
										/>
										<style>
											{`
									.home-component-review-card {
										// border: 1px solid #e0e0e0;
										box-shadow: 0px 6px 20px rgba(99, 115, 129, 0.12);
										border-radius: 8px;
										padding: 24px 24px 18px 24px;
										position: relative;
										margin: 12px 0;
									}
									.profile-info {
										display: flex;
										align-items: center;
										gap: 4px;
									}
									.beauty-level {
										font-family: 'Roboto';
										font-style: normal;
										font-weight: 400;
										font-size: 14px;
										line-height: 22px;
										color: #919EAB;
										text-transform: capitalize;
									}
									.profile-review {
										font-family: 'Roboto';
										font-style: normal;
										font-weight: 700;
										font-size: 12px;
										line-height: 16px;
										color: #DB284E;
									}

									.home-review-list-trending .card-profile-wrapper .text-wrapper .profile-username{
										font-weight: 600;
										font-size: 16px;
									}
									.home-review-list-trending .card-profile-wrapper .text-wrapper .profile-age{
										font-weight: 400;
										font-size: 14px;
										color: #919EAB;
									}
									.home-review-list-trending .card-profile-wrapper .text-wrapper .profile-description{
										font-weight: 500;
										font-size: 14px;
										color: #919EAB;
									}
									.home-review-list-trending .product-card .rating-wrapper .rating-text{
										font-weight: 400;
									}
									.home-review-list-trending .product-card .text-wrapper .product-brand{
										font-weight: 600;
										font-size: 14px;
									}
									.home-review-list-trending .product-card .text-wrapper .product-shade{
										font-weight: 400;
										font-size: 14px;
									}
								`}
										</style>
									</div>

								))}

								{
									prop.newestReviews.on_load && (
										<CardReviewSkeleton isMobile={false} />
									)
								}

							</div>
							{
								!prop.newestReviews.on_load
								&& prop.newestReviews.data.length < prop.newestReviews.total
									? (
										<div className="loadmore">
											<button
												type="button"
												className="loadmore-button"
												onClick={prop.handleLoadMore}
												id="id-loadmore"
											>
												LOAD MORE REVIEWS
											</button>
										</div>
									) : null
							}
						</>

					) : (
						<div className="error-container">
							<img className="asset-err" src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/error/404.png" alt="error 500" />
							<div className="desc">
								<p className="text-title">Uh oh!</p>
								<p className="text-desc">Something went wrong.</p>
								<p className="text-desc">Try to refresh this page or feel free to contact us if the problem persists.</p>
							</div>
						</div>
					)}

				<style>
					{`
						.pagination{
							width: 100%;
							margin: 2rem 0;
						}
						.pagination #id_up_page {
							display: none;
						}
						.paging-prev-text-active,
						.paging-prev-text-inactive,
						.paging-button,
						.paging-button-dots,
						.paging-button-active {
							font-family: Roboto, sans-serif;
							font-size: 16px;
						}
						.form-group {
							display: flex;
						}
						.review-card .text-right {
							text-align: right;
							justify-content: end;
						}
						.loadmore {
							width: 100%;
							display: flex;
							justify-content: center;
							margin: 24px 0;
							padding: 9px auto;
						}
						.loadmore-button{
							font-family: 'Poppins';
							font-style: normal;
							font-weight: 600;
							font-size: 16px;
							line-height: 24px;
							text-align: center;
							text-transform: capitalize;
							color: #DB284E;
							text-decoration: none;
							background: none;
							border: none;
							cursor: pointer
						}

					`}
				</style>
			</div>

			<style jsx>
				{`
          .home-top {
            width: 100%;
            padding-bottom: 12px;
          }

          .home-top-left {
						display: flex;
						align-items: center;
					}

          .home-top-text {
						font-family: Roboto;
						font-weight: bold;
						padding-left: 40px;
						font-size: 14px;
						word-spacing: 1px;
						text-transform: uppercase;
						margin: 0;
					}

          .home-review{
						display: flex;
						align-items: center;
						justify-content: center;
						flex-direction: column;
						//margin-bottom: 30px;		
						max-width: 880px;
					}

          .home-review-list-trending{
						display: flex;
						flex-direction: column;
						width: 880px;
					}

          .tabs-container {
            margin-top: 8px;
            display: flex;
            gap: 8px;
						overflow-x: scroll;
						overflow-y: hidden;
						white-space: nowrap;

						overflow: -moz-scrollbars-none;
						-ms-overflow-style: none;
          	}

					.tabs-container::-webkit-scrollbar { 
						width: 0 !important 
					}

					.error-container {
						display: flex;
						gap: 88px;
						margin-top: 120px;
					}
					.text-desc {
							font-family: Roboto;
							font-size: 16px;
							font-weight: 400;
							line-height: 34px;
							letter-spacing: 0em;
							color: #454F5B;
					}
					.text-title {
							font-family: Poppins;
							font-size: 32px;
							font-weight: 600;
							line-height: 42px;
							letter-spacing: 0em;
					}
        `}
			</style>
		</>
	);

};

export default Desktop;
